import { compact, padStart } from 'lodash'
import React from 'react'

const onlyNumbers = (value) =>
  String(value)
    .replaceAll(/[^0-9]/g, '')
    .replace(/^0+/, '')

function makeMoney(value) {
  value = onlyNumbers(value)
  value = padStart(value, 3, '0')

  const dollars = []
  for (let i = value.length - 2; i >= 0; i -= 3) dollars.push(value.substring(Math.max(i - 3, 0), i))

  return compact(dollars).reverse().join(',') + '.' + value.substring(value.length - 2)
}

export default function MoneyField({ field: { placeholder, system_only }, id, isNa, onChange, value, onBlur, className, disabled }) {
  const handleChange = (e) => onChange({ [id]: onlyNumbers(e.target.value) })
  const moneyValue = isNa ? '' : makeMoney(value || '')

  const props = {
    value: moneyValue,
    placeholder: isNa ? '' : placeholder,
    type: 'text',
    onChange: handleChange,
    onBlur,
    disabled,
  }

  return (
    <div className={className}>
      { system_only ? moneyValue : <input {...props} /> }
    </div>
  )
}
